// LM Audit d'acquisition — données propres au modèle Word, ajoutées par
// generateDocument (SignModif.js) au moment de la génération.
import { axesPourDocument, lignesExclues } from "./auditAcquisitionAxes";
import { calculHonorairesAudit, montant, nombre, taux } from "./auditHonoraires";

export const LM_AUDIT = "LM Audit d'acquisition.docx";

const MANQUANT = "[MANQUANT]";
const ouManquant = (v) => (v === "" || v === null || v === undefined ? MANQUANT : v);

export function donneesDocumentAudit(formData) {
  const hono = calculHonorairesAudit(formData);
  const prix = nombre(formData.prix_achat);
  const minimum = nombre(formData.montant_minimum);
  return {
    // §1 — prix d'achat envisagé (le modèle n'ajoute pas « € » ici)
    prix_achat: prix === null ? MANQUANT : `${montant(prix)} €`,
    // §2.2 — titres et lignes retenus ({#axes}…{/axes})
    axes: axesPourDocument(lignesExclues(formData.audit_lignes_exclues)),
    // §2.6 — bloc fixe ou proportionnel
    honoraires_fixes: !hono.proportionnel,
    honoraires_proportionnels: hono.proportionnel,
    taux_honoraires: ouManquant(taux(formData.taux_honoraires)),
    montant_minimum: minimum === null ? MANQUANT : montant(minimum),
    total_honoraires: ouManquant(montant(hono.ht)),
    TVA_honoraires: ouManquant(montant(hono.tva)),
    total_honoraires_ttc: ouManquant(montant(hono.ttc)),
  };
}
